<template>
    <main class="oidc-callback">
      <div v-if="!error" class="oidc-callback__card">
        <v-progress-circular indeterminate color="#e76f51" size="34" width="3" />
        <h1>Estamos iniciando tu sesión</h1>
        <p>Un instante, estamos preparando tu cuenta.</p>
      </div>
      <div v-else class="oidc-callback__card oidc-callback__card--error">
        <v-icon color="#e76f51" size="38">mdi-alert-circle-outline</v-icon>
        <h1>No pudimos completar el ingreso</h1>
        <p>{{ error }}</p>
        <v-btn depressed @click="$router.replace('/')">Volver al inicio</v-btn>
      </div>
    </main>
</template>
<script>
 import { mapActions,mapGetters } from 'vuex'

  export default {
    name: 'OidcCallback',
    data: () => ({ error: null }),
    methods: {
      ...mapActions([
        'oidcSignInCallback'
      ]),
      ...mapGetters([
        'oidcIsAuthenticated'
      ]),
    },
    computed:{
      loggedUser(){
        return this.oidcIsAuthenticated;
      }
    },
    mounted () {
      this.oidcSignInCallback(window.location.href)
        .then((redirectPath) => {
          this.$router.replace(redirectPath || '/')
        })
        .catch((err) => {
          console.error(err)
          this.error = err && err.message
            ? err.message
            : 'La autorización no pudo validarse. Intentá iniciar sesión nuevamente.'
        })
        /**/
    },
  }
</script>
<style scoped>
.oidc-callback{min-height:calc(100vh - 64px);display:flex;align-items:center;justify-content:center;background:#f8f5ef;padding:25px;font-family:Inter,Arial,sans-serif;color:#173347}.oidc-callback__card{background:#fff;width:100%;max-width:450px;padding:48px 36px;text-align:center;box-shadow:0 15px 35px rgba(23,51,71,.1)}.oidc-callback h1{font-family:Georgia,serif;font-size:30px;font-weight:400;margin:20px 0 10px}.oidc-callback p{color:#687983;line-height:1.6;font-size:14px;margin:0}.oidc-callback__card--error .v-icon{margin-bottom:3px}.oidc-callback__card--error .v-btn{background:#e76f51!important;color:#fff!important;border-radius:0!important;text-transform:none!important;letter-spacing:0!important;margin-top:24px;font-weight:700}
</style>
